import { RediaPlatformEnvironment } from "./interfaces";

export const getRediaPlatformBaseUrl = ({
  api,
  environment,
}: {
  api: "configuration" | "patron" | "search" | "library";
  environment: RediaPlatformEnvironment;
}) => `https://${api}${environment === "prod" ? "" : "-" + environment}.redia.dk/`;
